import { createContext } from 'react'
import { UserLocale } from '../types'

export const UserLocaleContext = createContext<UserLocale>(null)
